import { Dispatch, FC, SetStateAction } from 'react';
import { Avatar, Button, Col, Row, Space } from 'antd';
import { TbArrowUpRight, TbRefresh } from 'react-icons/tb';

import { CompanyLogoDarkSVG } from '@/assets';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useReportComponentStore } from '@/stores';
import { useDatasetStore } from '@/stores/database/aliases/datasets/store';
import { ReportComponent } from '@/types';

import { ResultsView } from '../..';
import { evaluateComponentReadiness } from '../../../../helpers/evaluateComponentReadiness';
import {
    buildReportComponentDatasetQueryConfiguration,
    getReportComponentDatasetQueryStateKey,
    getReportComponentDatasetRequestKey,
} from '../../../../helpers/hook';

interface FooterProps {
    component: ReportComponent;
    setSegmented: Dispatch<SetStateAction<ResultsView>>;
}

const Footer: FC<FooterProps> = ({ component, setSegmented }): JSX.Element => {
    const { token } = useAntDesignTheme();

    const { isReady } = evaluateComponentReadiness(component);
    const queryDatasets = useDatasetStore((state) => state.queryDatasets);
    const queryStateKey = getReportComponentDatasetQueryStateKey(component);
    const loading = useDatasetStore((state) => state.componentQueryState[queryStateKey]?.loading);
    const draft = useReportComponentStore((state) => state.draftConfigurations[component?.id as string]);

    const handleRefreshComponent = async () => {
        if (!isReady) {return;}

        const queryConfiguration = buildReportComponentDatasetQueryConfiguration(component, draft);

        if (!queryConfiguration) {return;}

        await queryDatasets(
            queryStateKey,
            queryConfiguration,
            getReportComponentDatasetRequestKey(queryStateKey, queryConfiguration),
            { force: true },
        );
    };

    return (
        <Row align={'middle'} style={{ padding: '1rem 1.25rem', borderTop: `1px solid ${token.colorBorder}` }}>
            {/* <Col flex='none'>
                                    <Segmented
                                        size='small'
                                        options={[
                                            {
                                                value: ResultsView.CHART,
                                                label: (
                                                    <>
                                                        <AreaChart
                                                            size='0.875rem'
                                                            style={{ verticalAlign: '-0.125rem', marginRight: '0.25rem' }}
                                                        />
                                                        Chart
                                                    </>
                                                ),
                                            },
                                            {
                                                value: ResultsView.TABLE,
                                                label: (
                                                    <>
                                                        <TableProperties
                                                            size='0.875rem'
                                                            style={{
                                                                transform: 'rotate(180deg)',
                                                                verticalAlign: '-0.125rem',
                                                                marginRight: '0.25rem',
                                                            }}
                                                        />
                                                        Table
                                                    </>
                                                ),
                                            },
                                            {
                                                value: ResultsView.JSON,
                                                label: (
                                                    <>
                                                        <TbBraces
                                                            style={{ verticalAlign: '-0.125rem', marginRight: '0.25rem' }}
                                                        />
                                                        JSON
                                                    </>
                                                ),
                                            },
                                            {
                                                value: ResultsView.SQL,
                                                label: (
                                                    <>
                                                        <TbZoomCode
                                                            style={{ verticalAlign: '-0.125rem', marginRight: '0.25rem' }}
                                                        />
                                                        SQL
                                                    </>
                                                ),
                                            },
                                        ]}
                                        onChange={(v) => setSegmented(v)}
                                    />
                                </Col> */}
            {/* <Col flex='none'>
                                    <Divider type='vertical' />
                                </Col> */}
            <Col flex='none'>
                <Button
                    size='small'
                    onClick={() => {
                        window.open('https://countercyclical.com', '_blank');
                    }}
                >
                    <Avatar
                        size={16}
                        style={{
                            border: `1px solid ${token.colorBorder}`,
                            backgroundColor: '#ffffff',
                        }}
                        icon={<img alt='Countercyclical' src={CompanyLogoDarkSVG} />}
                        shape='square'
                    />
                    Made in Countercyclical
                    <TbArrowUpRight style={{ color: token.colorTextTertiary }} />
                </Button>
            </Col>
            <Col flex='auto' />
            <Col flex='none'>
                <Space.Compact>
                    <Button size='small' loading={loading} onClick={handleRefreshComponent}>
                        <TbRefresh style={{ color: token.colorTextTertiary }} />
                    </Button>
                    {/* <Button size='small' style={{ padding: '0.25rem' }}>
                        <TbDownload style={{ color: token.colorTextTertiary }} />
                    </Button>
                    <Button size='small' style={{ padding: '0.25rem' }}>
                        <TbPrinter style={{ color: token.colorTextTertiary }} />
                    </Button> */}
                </Space.Compact>
            </Col>
        </Row>
    );
};

export default Footer;
